<button
  [class]="'btn ' + btnClasses()"
  [disabled]="disabled()"
  [id]="id()"
  [style.background-color]="backgroundColor()"
  [style.color]="color()"
  [style.border]="border()"
  [style.width]="width()"
  [style.height]="height()"
  *ngIf="btnLabel()">
  <img
    *ngIf="startIcon()?.src"
    [src]="startIcon()?.src"
    [alt]="startIcon()?.alt" />

  <span *ngIf="btnLabel()">
    {{ btnLabel() }}
  </span>

  <app-loader *ngIf="isLoading()"></app-loader>

  <img *ngIf="endIcon()?.src" [src]="endIcon()?.src" [alt]="endIcon()?.alt" />
</button>
